import { render, staticRenderFns } from "./CompanyNumbers.vue?vue&type=template&id=1ebfb989&scoped=true&"
import script from "./CompanyNumbers.vue?vue&type=script&lang=js&"
export * from "./CompanyNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebfb989",
  null
  
)

export default component.exports